<div [ngClass]="position" class="toast body-medium-regular"
  [ngClass]="{'success-toast': successToast, 'error-toast': errorToast}">
  {{ message | translate: translationParams }}
  <img src="assets/close-icon.svg" class="close-icon" (click)="closeToast(index)">
</div>
